module.exports = __webpack_public_path__ + "img/11.58c005af.jpg";